import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="multi-select"
// A <details> dropdown of checkboxes; keeps the summary text in sync with the selections.
// Optional filter: set filter-name to a radio group's name and give each option a data-category;
// only options whose category matches the checked radio (or all, when it is "both" or unset) are shown.
export default class extends Controller {
  static targets = ["summary", "option"]
  static values = { placeholder: String, filterName: String }

  connect() {
    this.filter()
    this.closeOnOutsideClick = (event) => {
      if (!this.element.contains(event.target)) this.element.open = false
    }
    document.addEventListener("click", this.closeOnOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutsideClick)
  }

  update() {
    const selected = this.optionTargets
      .filter((option) => option.checked)
      .map((option) => option.dataset.label)
    this.summaryTarget.textContent = selected.length ? selected.join(", ") : this.placeholderValue
  }

  filter(event) {
    if (event && event.target.name !== this.filterNameValue) return

    if (this.hasFilterNameValue) {
      const form = this.element.closest("form") || document
      const category = form.querySelector(`input[name="${this.filterNameValue}"]:checked`)?.value

      this.optionTargets.forEach((option) => {
        const visible = !category || category === "both" || option.dataset.category === category
        option.closest("label").classList.toggle("hidden", !visible)
        if (!visible) option.checked = false
      })
    }
    this.update()
  }
}
